// <auto-generated>
// This file is automatically generated by the Nexo CLI.
// Do not modify this file directly. Changes will be overwritten.
// Source: CLI help build (nexo help build) from the helpRef of business rules (dsl/rules) and enum values (dsl/enums)
// </auto-generated>

/** The help section (`<page id>#<anchor>`) of each error code whose rule names one, by the code the backend throws. */
export const ERROR_CODE_HELP: Record<string, string> = {
  "Nexo:Finance:DimensionValue:InUseCannotDelete": "finance.dimension-setup#in-use",
  "Nexo:Finance:PlanHeader:EntryBlockedWhileReevaluating": "finance.budget-entry#read-only",
  "Nexo:Finance:PlanHeader:ReevaluateAlreadyRunning": "finance.pending-lines#skipped",
  "Nexo:Finance:PlanHeader:ReevaluateNothingEligible": "finance.pending-lines#skipped",
  "Nexo:Finance:PlanHeader:ReevaluateRequiresEditableStatus": "finance.pending-lines#skipped",
  "Nexo:Finance:PlanHeader:ReevaluateRequiresEditableVersion": "finance.pending-lines#skipped",
  "Nexo:Finance:PlanHeader:ReevaluateSelectionContested": "finance.pending-lines#skipped",
  "Nexo:Finance:PlanHeader:ReturnRequiresApprovingCapacity": "finance.plan-header-submit#who",
  "Nexo:Finance:PlanHeader:SubmitBlockedByEmptyHeader": "finance.plan-header-submit#unavailable",
  "Nexo:Finance:PlanHeader:SubmitRequiresRowAccess": "finance.plan-header-submit#who",
  "Nexo:Finance:PlanLineReevaluationRun:SystemProduced": "finance.pending-lines#skipped",
  "Nexo:Finance:PlanScenario:InvalidScenarioType": "finance.new-budget-round#refused",
  "Nexo:Finance:PlanScenario:ScenarioCodeConflict": "finance.new-budget-round#refused",
  "Nexo:Finance:PlanScenario:SourceScenarioHasNoVersions": "finance.new-budget-round#refused",
  "Nexo:Finance:PlanScenario:SourceVersionNotInScenario": "finance.new-budget-round#refused",
  "Nexo:Finance:PlanScenario:TargetFiscalYearNotFound": "finance.new-budget-round#refused",
  "Nexo:Finance:PlanStatementTemplate:DuplicateRowCode": "finance.report-templates#checks",
  "Nexo:Finance:PlanStatementTemplate:FormulaCycle": "finance.report-templates#checks",
  "Nexo:Finance:PlanStatementTemplate:FormulaUnknownReference": "finance.report-templates#checks",
  "Nexo:Finance:PlanStatementTemplate:PercentOfUnknownReference": "finance.report-templates#checks",
  "Nexo:Finance:PlanVersion:ApprovalPending": "finance.plan-version-approval#approve",
  "Nexo:Finance:PlanVersion:BudgetPublishRequiresApprovedState": "finance.plan-version-publish#blocked",
  "Nexo:Finance:PlanVersion:PublishAlreadyInProgress": "finance.plan-version-publish#running",
  "Nexo:Finance:PlanVersion:PublishBlockedByLockedVersion": "finance.plan-version-lock#effect",
  "Nexo:Finance:PlanVersion:PublishBlockedByMissingReference": "finance.plan-version-publish#failed",
  "Nexo:Finance:PlanVersion:PublishBlockedByPendingLines": "finance.pending-lines#find",
  "Nexo:Finance:PlanVersion:PublishBlockedByReevaluation": "finance.pending-lines#skipped",
  "Nexo:Finance:PlanVersion:PublishRequiresLines": "finance.plan-version-publish#blocked",
  "Nexo:Finance:PlanVersion:SubmitBlockedByUnsubmittedHeaders": "finance.plan-version-approval#before",
  "Nexo:Finance:PlanVersion:SubmitRequiresBudgetScenario": "finance.plan-version-approval#before",
  "Nexo:Finance:PlanVersion:VersionNumberConflict": "finance.new-budget-round#refused",
  "Nexo:Finance:PlanVersion:WhatIfCannotBePublished": "finance.plan-version-publish#blocked",
  "Nexo:Finance:PlanView:DerivedAmountRequiresFormula": "finance.plan-view-setup#checks",
  "Nexo:Finance:PlanView:DuplicateFixedStorageBinding": "finance.plan-view-setup#checks",
  "Nexo:Finance:PlanView:DuplicateMeasureCode": "finance.plan-view-setup#checks",
  "Nexo:Finance:PlanView:DuplicateRowAxis": "finance.plan-view-setup#checks",
  "Nexo:Finance:PlanView:MeasureChangedAfterFiguresEntered": "finance.plan-views#freeze",
  "Nexo:Finance:PlanView:MeasureFormulaCycle": "finance.plan-view-setup#checks",
  "Nexo:Finance:PlanView:MeasureFormulaInvalid": "finance.plan-view-setup#checks",
  "Nexo:Finance:PlanView:MeasureFormulaRequiresDerivedKind": "finance.plan-view-setup#checks",
  "Nexo:Finance:PlanView:MeasureResultOutOfRange": "finance.plan-views#formulas",
  "Nexo:Finance:PlanView:MeasureWeightInvalid": "finance.plan-view-setup#checks",
  "Nexo:Finance:PlanView:MeasuresFrozenByPublishedVersion": "finance.plan-views#freeze",
  "Nexo:Finance:PlanView:MeasuresFrozenBySubmittedHeader": "finance.plan-views#freeze",
  "Nexo:Finance:PlanView:StorageBindingNotValidForKind": "finance.plan-view-setup#checks",
};

/** The help section of each enum value that names one, by `{Enum}:{CODE}`. */
export const ENUM_VALUE_HELP: Record<string, string> = {
  "MappingReason:AMBIGUOUS_ACCOUNT": "finance.pending-reasons#ambiguous-account",
  "MappingReason:AMBIGUOUS_DIMENSION": "finance.pending-reasons#ambiguous-dimension",
  "MappingReason:AMBIGUOUS_INTERNAL_PRICE": "finance.pending-reasons#ambiguous-internal-price",
  "MappingReason:INVALID_ACCOUNT": "finance.pending-reasons#invalid-account",
  "MappingReason:NO_ACCOUNT_RULE_MATCHED": "finance.pending-reasons#no-account-rule-matched",
  "MappingReason:NO_DIMENSION_RULE_MATCHED": "finance.pending-reasons#no-dimension-rule-matched",
  "MappingReason:NO_INTERNAL_PRICE_MATCHED": "finance.pending-reasons#no-internal-price-matched",
};

/** The entities on whose screens each enum value's help shows — those its page applies to — by `{Enum}:{CODE}`. */
export const ENUM_VALUE_HELP_ENTITIES: Record<string, readonly string[]> = {
  "MappingReason:AMBIGUOUS_ACCOUNT": ["PlanLine"],
  "MappingReason:AMBIGUOUS_DIMENSION": ["PlanLine"],
  "MappingReason:AMBIGUOUS_INTERNAL_PRICE": ["PlanLine"],
  "MappingReason:INVALID_ACCOUNT": ["PlanLine"],
  "MappingReason:NO_ACCOUNT_RULE_MATCHED": ["PlanLine"],
  "MappingReason:NO_DIMENSION_RULE_MATCHED": ["PlanLine"],
  "MappingReason:NO_INTERNAL_PRICE_MATCHED": ["PlanLine"],
};

/** The help section of each business rule that names one, by ruleKey. */
export const RULE_HELP: Record<string, string> = {
  "DIMENSION_DEFINITION_IN_USE_CANNOT_BE_DEACTIVATED": "finance.dimension-setup#in-use",
  "DIMENSION_DEFINITION_IN_USE_CANNOT_BE_DELETED": "finance.dimension-setup#in-use",
  "DIMENSION_VALUE_IN_USE_CANNOT_BE_DELETED": "finance.dimension-setup#in-use",
  "PLAN_ENTRY_EDIT_BLOCKED_WHILE_REEVALUATING": "finance.budget-entry#read-only",
  "PLAN_HEADER_REEVALUATE_NOT_ALREADY_RUNNING": "finance.pending-lines#skipped",
  "PLAN_HEADER_REEVALUATE_REQUIRES_EDITABLE_STATUS": "finance.pending-lines#skipped",
  "PLAN_HEADER_REEVALUATE_REQUIRES_EDITABLE_VERSION": "finance.pending-lines#skipped",
  "PLAN_HEADER_REEVALUATE_REQUIRES_ELIGIBLE_SELECTION": "finance.pending-lines#skipped",
  "PLAN_HEADER_RETURN_REQUIRES_APPROVING_CAPACITY": "finance.plan-header-submit#who",
  "PLAN_HEADER_SUBMIT_REQUIRES_LINES": "finance.plan-header-submit#unavailable",
  "PLAN_HEADER_SUBMIT_REQUIRES_ROW_ACCESS": "finance.plan-header-submit#who",
  "PLAN_LINE_REEVALUATION_RUN_IS_SYSTEM_PRODUCED": "finance.pending-lines#skipped",
  "PLAN_SCENARIO_CODE_UNIQUE": "finance.new-budget-round#refused",
  "PLAN_SCENARIO_COPY_REQUIRES_SOURCE_VERSION": "finance.new-budget-round#refused",
  "PLAN_SCENARIO_COPY_SOURCE_VERSION_MUST_BELONG_TO_SCENARIO": "finance.new-budget-round#refused",
  "PLAN_SCENARIO_COPY_TARGET_FISCAL_YEAR_MUST_EXIST": "finance.new-budget-round#refused",
  "PLAN_SCENARIO_COPY_TYPE_MUST_BE_KNOWN": "finance.new-budget-round#refused",
  "PLAN_STATEMENT_FORMULAS_MUST_BE_ACYCLIC": "finance.report-templates#checks",
  "PLAN_STATEMENT_ROW_CODE_UNIQUE": "finance.report-templates#checks",
  "PLAN_STATEMENT_ROW_REFERENCES_MUST_RESOLVE": "finance.report-templates#checks",
  "PLAN_VERSION_APPROVE_BLOCKED_BY_PENDING_APPROVAL": "finance.plan-version-approval#approve",
  "PLAN_VERSION_BUDGET_PUBLISH_REQUIRES_APPROVED_STATE": "finance.plan-version-publish#blocked",
  "PLAN_VERSION_NUMBER_UNIQUE_PER_SCENARIO": "finance.new-budget-round#refused",
  "PLAN_VERSION_PUBLISH_ALREADY_IN_PROGRESS": "finance.plan-version-publish#running",
  "PLAN_VERSION_PUBLISH_BLOCKED_BY_LOCKED_VERSION": "finance.plan-version-lock#effect",
  "PLAN_VERSION_PUBLISH_BLOCKED_BY_MISSING_REFERENCE": "finance.plan-version-publish#failed",
  "PLAN_VERSION_PUBLISH_BLOCKED_BY_PENDING_LINES": "finance.pending-lines#find",
  "PLAN_VERSION_PUBLISH_BLOCKED_WHILE_REEVALUATING": "finance.pending-lines#skipped",
  "PLAN_VERSION_PUBLISH_REQUIRES_LINES": "finance.plan-version-publish#blocked",
  "PLAN_VERSION_SUBMIT_BLOCKED_BY_UNSUBMITTED_HEADERS": "finance.plan-version-approval#before",
  "PLAN_VERSION_SUBMIT_REQUIRES_BUDGET_SCENARIO": "finance.plan-version-approval#before",
  "PLAN_VERSION_WHAT_IF_CANNOT_BE_PUBLISHED": "finance.plan-version-publish#blocked",
  "PLAN_VIEW_DERIVED_AMOUNT_REQUIRES_FORMULA": "finance.plan-view-setup#checks",
  "PLAN_VIEW_FIXED_STORAGE_BINDING_SINGLE": "finance.plan-view-setup#checks",
  "PLAN_VIEW_MEASURES_FROZEN_BY_PUBLISHED_VERSION": "finance.plan-views#freeze",
  "PLAN_VIEW_MEASURES_FROZEN_BY_SUBMITTED_HEADER": "finance.plan-views#freeze",
  "PLAN_VIEW_MEASURE_CHANGED_AFTER_FIGURES_ENTERED": "finance.plan-views#freeze",
  "PLAN_VIEW_MEASURE_CODE_UNIQUE": "finance.plan-view-setup#checks",
  "PLAN_VIEW_MEASURE_FORMULAS_MUST_BE_ACYCLIC": "finance.plan-view-setup#checks",
  "PLAN_VIEW_MEASURE_FORMULA_MUST_CHECK": "finance.plan-view-setup#checks",
  "PLAN_VIEW_MEASURE_FORMULA_REQUIRES_DERIVED_KIND": "finance.plan-view-setup#checks",
  "PLAN_VIEW_MEASURE_STORAGE_BINDING_MUST_MATCH_KIND": "finance.plan-view-setup#checks",
  "PLAN_VIEW_MEASURE_VALUE_MUST_FIT_DECIMAL": "finance.plan-views#formulas",
  "PLAN_VIEW_MEASURE_WEIGHT_MUST_BE_ADDITIVE_SIBLING": "finance.plan-view-setup#checks",
  "PLAN_VIEW_ROW_AXIS_UNIQUE_PER_ROOT": "finance.plan-view-setup#checks",
  "PUBLISHED_PLAN_VERSION_CANNOT_BE_DELETED": "finance.plan-versions#delete",
};
